export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2014.4d5293da.pdf";